import Vue from 'vue'
import Router from 'vue-router'
import store  from '../store'
import cookie from "../static/cookie";
//页面加载进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 简单配置
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 视图主体结构
import layout from '@/views/layout'

const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index')},
  { path: '/', component: () => import('@/views/home/index')},
  // {
  //   path: '/',
  //   name: 'layout',
  //   component: layout,
  //   redirect: '/main',
  //   meta: {
  //     title: '控制台'
  //   },
  //   children: [
  //     {
  //       path: '/main',
  //       name: 'main',
  //       component: () => import('@/views/main/index'),
  //       meta: {
  //         title: '控制台',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/transferInfo',
  //       name: 'transferInfo',
  //       component: () => import('@/views/transferInfo/index'),
  //       meta: {
  //         title: '专利转让信息',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/transferInfoDetail',
  //       name: 'transferInfoDetail',
  //       component: () => import('@/views/details/transferInfoDetail'),
  //       meta: {
  //         title: '专利转让信息详情',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/needInfo',
  //       name: 'needInfo',
  //       component: () => import('@/views/needInfo/index'),
  //       meta: {
  //         title: '技术需求信息',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/needInfoDetail',
  //       name: 'needInfoDetail',
  //       component: () => import('@/views/details/needInfoDetail'),
  //       meta: {
  //         title: '技术需求信息详情',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/transferInfoPublish',
  //       name: 'transferInfoPublish',
  //       component: () => import('@/views/publish/transferInfoPublish'),
  //       meta: {
  //         title: '专利转让信息发布',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/needInfoPublish',
  //       name: 'needInfoPublish',
  //       component: () => import('@/views/publish/needInfoPublish'),
  //       meta: {
  //         title: '技术需求信息发布',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/lHaveTransfer',
  //       name: 'lHaveTransfer',
  //       component: () => import('@/views/lHaveTransfer/index'),
  //       meta: {
  //         title: '我已发布的转让信息',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/lHavetransferInfoDetail',
  //       name: 'lHavetransferInfoDetail',
  //       component: () => import('@/views/details/lHavetransferInfoDetail'),
  //       meta: {
  //         title: '我已发布的转让信息详情',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/lHaveNeed',
  //       name: 'lHaveNeed',
  //       component: () => import('@/views/lHaveNeed/index'),
  //       meta: {
  //         title: '我已发布的需求信息',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/lHaveNeedInfoDetail',
  //       name: 'lHaveNeedInfoDetail',
  //       component: () => import('@/views/details/lHaveNeedInfoDetail'),
  //       meta: {
  //         title: '我已发布的需求信息详情',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/transferLicence',
  //       name: 'transferLicence',
  //       component: () => import('@/views/transferLicence/index'),
  //       meta: {
  //         title: '专利转让许可项目反馈',
  //         listShow: true
  //       }
  //     },
  //     {
  //       path: '/foundUsers',
  //       name: 'foundUsers',
  //       component: () => import('@/views/foundUsers/index'),
  //       meta: {
  //         title: '创建用户',
  //         listShow: true
  //       }
  //     }
  //   ]
  // },
  {
    path: '/layout',
    name: 'layout',
    component: layout,
    redirect: '/main',
    meta: {
      title: '控制台'
    },
    children: [
      {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '控制台',
          listShow: true
        }
      },
      {
        path: '/transferInfo',
        name: 'transferInfo',
        component: () => import('@/views/transferInfo/index'),
        meta: {
          title: '专利转让信息',
          listShow: true
        }
      },
      {
        path: '/transferInfoDetail',
        name: 'transferInfoDetail',
        component: () => import('@/views/details/transferInfoDetail'),
        meta: {
          title: '专利转让信息详情',
          listShow: true
        }
      },
      {
        path: '/needInfo',
        name: 'needInfo',
        component: () => import('@/views/needInfo/index'),
        meta: {
          title: '技术需求信息',
          listShow: true
        }
      },
      {
        path: '/needInfoDetail',
        name: 'needInfoDetail',
        component: () => import('@/views/details/needInfoDetail'),
        meta: {
          title: '技术需求信息详情',
          listShow: true
        }
      },
      {
        path: '/transferInfoPublish',
        name: 'transferInfoPublish',
        component: () => import('@/views/publish/transferInfoPublish'),
        meta: {
          title: '专利转让信息发布',
          listShow: true
        }
      },
      {
        path: '/needInfoPublish',
        name: 'needInfoPublish',
        component: () => import('@/views/publish/needInfoPublish'),
        meta: {
          title: '技术需求信息发布',
          listShow: true
        }
      },
      {
        path: '/lHaveTransfer',
        name: 'lHaveTransfer',
        component: () => import('@/views/lHaveTransfer/index'),
        meta: {
          title: '我已发布的转让信息',
          listShow: true
        }
      },
      {
        path: '/lHavetransferInfoDetail',
        name: 'lHavetransferInfoDetail',
        component: () => import('@/views/details/lHavetransferInfoDetail'),
        meta: {
          title: '我已发布的转让信息详情',
          listShow: true
        }
      },
      {
        path: '/lHaveNeed',
        name: 'lHaveNeed',
        component: () => import('@/views/lHaveNeed/index'),
        meta: {
          title: '我已发布的需求信息',
          listShow: true
        }
      },
      {
        path: '/lHaveNeedInfoDetail',
        name: 'lHaveNeedInfoDetail',
        component: () => import('@/views/details/lHaveNeedInfoDetail'),
        meta: {
          title: '我已发布的需求信息详情',
          listShow: true
        }
      },
      {
        path: '/transferLicence',
        name: 'transferLicence',
        component: () => import('@/views/transferLicence/index'),
        meta: {
          title: '专利转让许可项目反馈',
          listShow: true
        }
      },
      {
        path: '/foundUsers',
        name: 'foundUsers',
        component: () => import('@/views/foundUsers/index'),
        meta: {
          title: '创建用户',
          listShow: true
        }
      }
    ]
  },
]
const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap 
})
let isToken;
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  isToken = cookie.getCookie("token")
  if (isToken) {
    if (to.path == '/login') {
      NProgress.done();
      next({ path: '/' })
    }else {
      if (store.state.routers.routers.length == 0) {
        const accessRouteses = router.options.routes.splice(1,1)
        store.commit('routers/getRouters', accessRouteses)
        next()
      }else {
        let accessRouteses = router.options.routes.splice(1,1)
        store.commit('routers/getRouters', accessRouteses)
        NProgress.done();
        next()
      }
    }
  }else {
    if (isToken == false && to.path !== '/login') {
			next("/login")
		}else {
      NProgress.done();
			next()
		}
  }
})
// function routerCom(path) { //对路由的component解析
// 	return (resolve) => require([`@/views/${path}`], resolve);
// }
// function routerChildren(children) { //对子路由的component解析
// 	children.forEach(v => {
// 		v.component = routerCom(v.component);
// 		if (v.children != undefined) {
// 			v.children = routerChildren(v.children)
// 		}
// 	})
// 	return children
// }

router.afterEach(() => {
  NProgress.done(); // 一定要关闭进度条
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js